import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { EClientData } from "dto/IClient";
import StarIcon from "assets/icons/star.svg?react";

import CopyIcon from "assets/icons/copye.svg?react";

import CloseIcon from "assets/icons/close.svg?react";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const AddressClientModal: FC<Props> = ({ client, refWrapper }) => {
  const { t } = useTranslation();
  if (!refWrapper?.current) return <></>;

  const position = refWrapper.current.getBoundingClientRect();

  const addresses = client.Data.filter((d) => d.Type === EClientData.ADDRESS);

  return ReactDOM.createPortal(
    <div
      style={{
        left: `${position.left}px`,
        top: `${position.top + 32}px`,
      }}
      className={styles.wrapper}
    >
      <div className={styles.title}>
        {t("forms.address")}
        <CloseIcon className={styles.icon} />
      </div>
      {addresses.map((a) => {
        try {
          const json = JSON.parse(a.Value);

          return (
            <div className={styles.box}>
              <div className={styles.data}>
                <div className={styles.address}>
                  {json.Address ?? json.address}, {json.ZipCode ?? json.zipCOde}{" "}
                  {json.City ?? json.city}
                </div>
              </div>
              <div className={styles.options}>
                <Tooltip title={t("common.copy")}>
                  <div>
                    <CopyIcon
                      className={`${styles.icon} ${styles.copy}`}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          ` ${json.ZipCode ?? json.zipCOde} ${
                            json.City ?? json.city
                          }` ?? ""
                        );
                      }}
                    />
                  </div>
                </Tooltip>
                {a.IsMain && <StarIcon className={styles.icone} />}
              </div>
            </div>
          );
        } catch { /* parse error – fall through to default render */ }

        return <div className={styles.name}>{a.Value}</div>;
      })}
    </div>,
    document.body
  );
};

export default AddressClientModal;
